import React from 'react';
import { jc } from 'utils';
import { StoreStockData } from 'common/components/stocks-in-stores/types';
import { PickupOption } from 'common/components/stocks-in-stores/pickup-option';
import { DeliveryOption, DeliveryOptionProps } from './components';
import { delivMethodOptNew, delivMethodsCntrNew } from './delivery-methods.styles';
import { returnUnavailableDeliveryType } from './utils/return-unavailable-delivery-type';
import { DeliveryOptionUnavailable } from './components/delivery-option/delivery-option-unavailable';

type DeliveryMethodsPropsNew = {
  stocks: StoreStockData[];
  options: DeliveryOptionProps[];
} & React.HTMLAttributes<HTMLElement>;

export const DeliveryMethods: React.FC<DeliveryMethodsPropsNew> = ({
  stocks,
  options,
  className,
  ...htmlProps
}) => {
  const unavailableDelivery = returnUnavailableDeliveryType(options);
  const stockInStoresEmpty =
    stocks.length === 0 ||
    stocks.filter(({ stockValue }: { stockValue: number }) => stockValue > 0).length === 0;
  const displaySampleAvailable =
    stockInStoresEmpty && stocks.filter((stock) => !!stock.displaySample).length > 0;
  /**
   When we have empty stocks in physical shops we still may be able to receive goods via them
   after delivery from darkstores
   Then we don't have <PickupOption /> but instead we display <DeliveryOption /> with the nearest
   available pickup date
   */
  const maxStockPickup = options.find((item) => item.type === 'PICKUP')?.maxStockAvailable || 0;
  const isPickup = options.some((item) => item.type === 'PICKUP');
  const isPickupAvailable = isPickup && !stockInStoresEmpty;
  const availablePickupLongtail = stockInStoresEmpty && maxStockPickup > 0;
  const unavailablePickupPoint = (option: DeliveryOptionProps) =>
    option.type === 'PICKUP_POINT' && displaySampleAvailable;

  return (
    <div className={jc(delivMethodsCntrNew, className || '')} data-qa="delivery-methods" {...htmlProps}>
      {!availablePickupLongtail && !displaySampleAvailable && (
        <PickupOption isAvailable={isPickupAvailable} />
      )}
      {options.map((option) => (
        <div key={`${option.type}`} className={delivMethodOptNew} data-qa="delivery-method-cntr">
          {unavailablePickupPoint(option) && <DeliveryOptionUnavailable type={'PICKUP_POINT'} />}
          {option.type !== 'PICKUP' && unavailableDelivery === 'PICKUP_POINT' && (
            <DeliveryOptionUnavailable type={unavailableDelivery} />
          )}
          {((availablePickupLongtail && option.type === 'PICKUP') ||
            (option.type !== 'PICKUP' && !unavailablePickupPoint(option))) && <DeliveryOption {...option} />}
          {option.type !== 'PICKUP' && unavailableDelivery === 'HOME_DELIVERY' && (
            <DeliveryOptionUnavailable type={unavailableDelivery} />
          )}
        </div>
      ))}
    </div>
  );
};
